import { Component, ViewChild, OnInit, Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "./auth/services/auth.service";
import { TimerService } from "./shared/services/timer.service";
import { CacheService } from "../app/shared/services/cache.service";
import { apiEndPoints } from "../app/shared/services/utils/apiEndPointConstants";
import { AnalyticsService } from "./features/fnol/services/analytics.service";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { FnolService } from "./features/fnol/services/fnol.service";
import { CommonUtils } from "./features/fnol/shared/utils/common-utils";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
//test
export class AppComponent implements OnInit {
  @ViewChild("sessionTimeoutModal") sessionTimeoutModal: any;
  public remainingTime = null;
  public timeElapsed = false;
  public noTimerUrls = [
    "/registration/1",
    "/registration/2",
    "/registration/3",
    "/login",
    "/forgot-password",
  ];
  public pauseTimer = false;
  constructor(
    private authService: AuthService,
    private timerService: TimerService,
    private router: Router,
    private fnolService: FnolService,
    private cacheService: CacheService,
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    @Inject(OKTA_AUTH)
    public oktaAuth: OktaAuth,

  ) {
    console.log("===========================================");
    console.log("#####9/27/2023 Build 2#####") ;
    console.log("===========================================");
    console.log("===========================================");
    console.log("#####9/28/2023 Build 2#####") ;
    console.log("===========================================");
  }

  ngOnInit() {
    this.oktaAuth
      .isAuthenticated()
      .then((isAuthenticated) => {
          console.log("isAuthenticated",isAuthenticated)
        if (isAuthenticated) {
          return this.oktaAuth.getUser();
        }
      })
      .then((user) => {
        if (user) {
          console.log(user);

          this.cacheService.setUserid(user["email"]);
        }
      });
    /*  interval(1000).subscribe((val) => {
      if (this.findUrlInNoTimerUrls(window.location.pathname) == false && this.pauseTimer == false) {
        this.timerService.updateTime();
        if (this.timeElapsed == false) {
          this.remainingTime = this.timerService.getRemainingTime('mm:ss');
        } else {
          this.remainingTime = "00:00";
        }
        //console.log(this.remainingTime);

        if (this.remainingTime == TimerService.CDP_POPUP_TIME) {
        //  this.sessionTimeoutModal.open();
        } else if (this.remainingTime == "00:00") {
          this.timeElapsed = true;
        }
      }
    }); */
    const path = window.location.pathname;
    const region = path.match('jp') || path.match('singapore') || path.match('sg')||path.match('no');
    const queryParams = new URLSearchParams(window.location.search);
    const queryParam = queryParams.get("country");
    let analyticsPath : any = '';

    if (region && region.length) {
      analyticsPath = region[0];
    } else if (queryParam) {
      analyticsPath = queryParam;
    }
    this.analyticsService.addAnalyticsURL(analyticsPath).then(() => {}).catch((err) => {});
    const urlParams = new URLSearchParams(window.location.search);
    const partner = urlParams.get("partner");
    if (partner && partner.toLowerCase() == "gojek") {
      this.router.navigate(["/cdp/error"]);
    }
    const getGegion = path.match('us') || path.match('au') || path.match('nz') ||  path.match('US') || path.match('AU') || path.match('NZ') || path.match('no') ||  path.match('SG');
    if (getGegion) {
      analyticsPath = analyticsPath === "" ? getGegion[0] : analyticsPath
    }
    if (analyticsPath) {
      this.fnolService.setCountry(analyticsPath == "singapore" ? "SG" : analyticsPath);
    }

    // Load country-specific styles dynamically
    const isJP = path.match('JP') || path.match('jp');
    if (isJP) {
      this.loadJPStyles();
      this.removeNonJPStyles();
    } else {
      this.loadNonJPStyles();
      this.removeJPStyles();
    }

  }

  private loadJPStyles(): void {
    // Check if already loaded
    if (document.getElementById('jp-dynamic-styles')) {
      console.log('JP styles already loaded');
      return;
    }

    // Dynamically load JP-specific compiled CSS
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'main-jp.css';
    link.id = 'jp-dynamic-styles';
    link.onload = () => console.log('JP-specific styles (source-jp, index with Meiryo, axis) loaded successfully');
    link.onerror = () => console.error('Failed to load JP-specific styles');
    head.appendChild(link);
  }

  private loadNonJPStyles(): void {
    // Check if already loaded
    if (document.getElementById('non-jp-dynamic-styles')) {
      console.log('Non-JP styles already loaded');
      return;
    }

    // Dynamically load non-JP compiled CSS
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'main-other.css';
    link.id = 'non-jp-dynamic-styles';
    link.onload = () => console.log('Non-JP styles (source, theming/external/main) loaded successfully');
    link.onerror = () => console.error('Failed to load Non-JP styles');
    head.appendChild(link);
  }

  private removeJPStyles(): void {
    const jpStyles = document.getElementById('jp-dynamic-styles');
    if (jpStyles) {
      jpStyles.remove();
      console.log('JP styles removed');
    }
    // Also check for any main-jp.css links
    const links = document.querySelectorAll('link[href*="main-jp.css"]');
    links.forEach(link => link.remove());
  }

  private removeNonJPStyles(): void {
    const nonJpStyles = document.getElementById('non-jp-dynamic-styles');
    if (nonJpStyles) {
      nonJpStyles.remove();
      console.log('Non-JP styles removed');
    }
    // Also check for any main-other.css links
    const links = document.querySelectorAll('link[href*="main-other.css"]');
    links.forEach(link => link.remove());
  }


  findUrlInNoTimerUrls(str) {
    return this.noTimerUrls.some(function (s) {
      return s.toLowerCase().indexOf(str.toLowerCase()) > -1;
    });
  }

  continueTimeout() {
    this.pauseTimer = true;
    if (this.getUserId() != "") {
    }
  }

  logoutUser() {
    this.router.navigate(["/login/logout"]);
  }

  getUserId() {
    // let userId = this.cacheService.get(this.cacheService.USERID, CacheService.COOKIE_STORAGE);
    let userId = apiEndPoints.userid;
    if (userId) {
      return userId;
    } else {
      this.logoutUser();
    }
  }

  navigateToCommonServiceErrorPage() {
    this.router.navigate(["/registration/message"], {
      queryParams: { type: "commonServiceErrorPage" },
    });
  }
}
